"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateMapper = templateMapper;
const initialDataMapper_1 = require("./initialDataMapper");
function templateMapper(template, additionalData) {
    const { chatInfo } = additionalData;
    if (chatInfo) {
        (0, initialDataMapper_1.initialDataMapper)(template, chatInfo);
    }
    return template;
}
